import { PaymentOrderType } from "../../warmi/accounts-receivable/model/paymentOrder.model"; 
import { DropdownFilterDetail } from "../filter/dropdown-filter/dropdown-filter.component"; 

export enum UtilsEnum {
  DEFAULT_BOUNCE_TIME = 3000
}
export class Utils {
   public static validateImage(file: any): boolean {
    var allowedExtensions = ['image/jpg', 'image/jpeg', 'image/png'];
    // let fileExtension = file.name.split('.').pop();
    if (!allowedExtensions.find((a) => a?.toLowerCase() == file.type?.toLowerCase())) {
      return false;
    }
    return true;
  }

  public static validateImageFavicon(file: any): boolean {
    var allowedExtensions = ['image/ico','image/x-icon'];
    if (!allowedExtensions.find((a) => a?.toLowerCase() == file.type?.toLowerCase())) {
      return false;
    }
    return true;
  }

  public static validateFile(file: any): boolean {
    var allowedExtensions = ['xlsx', 'xlsm', 'xltx', 'xls', 'csv', 'xlsb'];
   let fileExtension = file.name.split('.').pop();
    if (!allowedExtensions.find((a) => a?.toLowerCase() == fileExtension?.toLowerCase())) {
      return false;
    }
    return true;
  }

  public static validateFileReconciliationDetails(file : any): boolean{
    var allowedExtensions = ['csv', 'PDF', 'pdf', 'txt'];
    let fileExtension = file.name.split('.').pop();
    if(!allowedExtensions.find((a) => a?.toLocaleLowerCase() == fileExtension?.toLowerCase())){
      return false;
    }
    return true;
  }

  public static validateFileWithFormat(file: any , allowedExtensions : string[]): boolean {
   let fileExtension = file.name.split('.').pop();
    if (!allowedExtensions.find((a) => a.replace(".","")?.toLowerCase() == fileExtension?.toLowerCase())) {
      return false;
    }
    return true;
  }

  public static validateVoucher(file: any): boolean {
    var allowedExtensions = ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'];
    if (!allowedExtensions.find((a) => a?.toLowerCase() == file.type?.toLowerCase())) {
      return false;
    }
    return true;
  }

  public static typeImagesAccepted() {
    return ['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG'];
  }

  public static typeImagesAcceptedFavicon() {
    return ['.ico'];
  }

  public static typeFilesAccepted() {
    return ['.xlsx', '.xlsm', '.xltx', '.xls', '.csv', '.xlsb'];
  }

  public static attachmentFilesAccepted() {
    return ['.xlsx', '.xlsm', '.xltx', '.xls', '.doc', '.pdf', '.json', '.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG', ".txt", ".csv", ".docx", ".xml", ".zip", ".rar", ".html", '.xlsb'];
  }

  public static pdfFiles() {
    return ['.PDF', '.pdf'];
  }

  public static typeVouchersAccepted() {
    return ['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG', '.PDF', '.pdf'];
  }

  public static fileMappingFormatAccepted() {
    return ['.xlsx', '.xlsm', '.xltx', '.xls', '.csv', '.xlsb'];
  }

  public static purcharseOrderFormatAccept(){
    return ['.jpg', '.png', '.jpeg', '.pdf', '.docx'];
  }

  public static attachmentFilesPaymentOrderAccepted() {
    return ['.xlsx', '.xlsm', '.xltx', '.xls', '.doc', '.pdf', '.PDF', '.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG', ".txt", ".csv", ".docx", ".xml", ".zip", ".rar", ".html", '.xlsb','.gif'];
  }

  public static ReconciliationDetailsFilesAccepted(){
    return ['.csv', '.PDF', '.pdf', '.txt']
  }

  public static whatsappCloudApiFilesAccepted() {
    return ['.pdf', '.jpeg', '.jpg', '.png', '.mp4'];
  }

  public static getCommonFilter() : DropdownFilterDetail[] {
    return [
      Utils.getCommonAllValue(),
      {label : "COMMON.FILTER_LIST.NONE", value : Utils.getNoneFilterValue()},
    ];
  }

  public static getCommonAllValue() : DropdownFilterDetail {
    return {label : "COMMON.FILTER_LIST.ALL", value : Utils.getAllFilterValue()};
  }

  public static getCommonAiAgentValue() : DropdownFilterDetail {
    return {label : "COMMON.FILTER_LIST.AI_AGENT", value : Utils.getAiAgentFilterValue()};
  }

  public static getAllFilterValue(){
    return -1111;
  }

  public static getNoneFilterValue(){
    return -9999;
  }

  public static getAiAgentFilterValue(){
    return -8888;
  }

  public static maxSizeFile(){
    return 10 * 1000 * 1000;
  }

  public static maxSizeFileByMB(mb : number){
    return mb * 1000 * 1000;
  }

  public static maxSizeFileByMassiveProcess(){
    return this.maxSizeFileByMB(200);
  }

  public static validateSignalAmountOrBalanceForPaymentOrderType(paymentOrderType : string, amount : number){
    if(paymentOrderType == PaymentOrderType.CUSTOMER_ADVANCES || paymentOrderType == PaymentOrderType.UNAPPLIED_PAYMENTS){
      if (amount > 0) return -Math.abs(amount);
      if (amount < 0) return Math.abs(amount); 
      return 0;
    }else{
      return amount;
    }
  }

}
